export enum CheckType {
    REVISABILITY,
    DECLINATURE,
    WARNING,
    CONFIRM,
    CONFIRM2,
    MICRO_RIDER_CONFIRM,
    MICRO_ROLE_CONFIRM,
}
